var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 8,
    viewBox: "0 0 46 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3536 4.03519C45.5488 3.83993 45.5488 3.52335 45.3536 3.32809L42.1716 0.146107C41.9763 -0.0491555 41.6597 -0.0491555 41.4645 0.146107C41.2692 0.341369 41.2692 0.657951 41.4645 0.853214L44.2929 3.68164L41.4645 6.51007C41.2692 6.70533 41.2692 7.02191 41.4645 7.21717C41.6597 7.41244 41.9763 7.41244 42.1716 7.21717L45.3536 4.03519ZM0 3.68164V4.18164H45V3.68164V3.18164H0V3.68164Z",
    fill: "#143A72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLong);
export default __webpack_public_path__ + "static/media/ARROW_LONG.0ad10720e68745adbe98a324df4b3bba.svg";
export { ForwardRef as ReactComponent };